/* istanbul ignore file */
import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { EMPLOYEE_WORKPLACE_LOCATION } from 'domain/shared/employee';

const EmployeeWorkplaceDropdown = (props: DefaultDropdownProps) => (
  <Dropdown
    placeholder="Choose Worker Workplace Location"
    options={Object.entries(EMPLOYEE_WORKPLACE_LOCATION).map(([value, label]) => ({ value, label }))}
    label="Workplace"
    {...props}
  />
);

export default EmployeeWorkplaceDropdown;
